export const PERFORMANCE_PAGE_TYPE = {
  OTHER: 0,
  HOME: 1,
  GOODS_LIST: 2,
  GOODS_DETAIL: 3,
} as const;

export type PerformancePageType =
  (typeof PERFORMANCE_PAGE_TYPE)[keyof typeof PERFORMANCE_PAGE_TYPE];

function normalizePathname(pathname: string): string {
  const cleanPathname = pathname.split('?')[0] || '/';
  if (cleanPathname === '/') {
    return '/';
  }
  return cleanPathname.replace(/\/+$/, '');
}

export function resolvePerformancePageType(pathname: string): PerformancePageType {
  const cleanPathname = normalizePathname(pathname);

  if (cleanPathname === '/') {
    return PERFORMANCE_PAGE_TYPE.HOME;
  }

  if (cleanPathname.startsWith('/goods-list/')) {
    return PERFORMANCE_PAGE_TYPE.GOODS_LIST;
  }

  if (cleanPathname.startsWith('/goods-detail/')) {
    return PERFORMANCE_PAGE_TYPE.GOODS_DETAIL;
  }

  return PERFORMANCE_PAGE_TYPE.OTHER;
}

export function shouldReportPerformancePage(pathname: string): boolean {
  return resolvePerformancePageType(pathname) !== PERFORMANCE_PAGE_TYPE.OTHER;
}
